module.exports = __webpack_public_path__ + "img/sinpas-logo.e9c74642.jpg";